/**
 * @author Jersson Morales
 * @Copyright (c) Infotrack. All rights reserved.
 */
import { IRespuesta } from '@infotrack/presentacion-transversales/interfacesComunes';
import manejadorRest from '@infotrack/presentacion-utilitarios/manejadorRest';
import { seguridad } from '../../conexiones';
import ITipoContribuyente from './entidades/tipoContribuyente';

export default class ModeloTipoContribuyente {
    public consultarTipoContribuyente() {
        return manejadorRest<IRespuesta<ITipoContribuyente>>(() =>
            seguridad.get('TipoContribuyente/ConsultarListaTipoContribuyente')
        );
    }
    public crearTipoContribuyente(tipoContribuyente: ITipoContribuyente) {
        return manejadorRest<IRespuesta<ITipoContribuyente>>(() =>
            seguridad.post('TipoContribuyente/GuardarTipoContribuyente', tipoContribuyente)
        );
    }
    public editarTipoContribuyente(tipoContribuyente: ITipoContribuyente) {
        return manejadorRest<IRespuesta<ITipoContribuyente>>(() =>
            seguridad.put('TipoContribuyente/EditarTipoContribuyente', tipoContribuyente)
        );
    }
    public eliminarTipoContribuyente(tipoContribuyente: ITipoContribuyente) {
        return manejadorRest<IRespuesta<ITipoContribuyente>>(() =>
            seguridad.delete('TipoContribuyente/EliminarTipoContribuyente', tipoContribuyente)
        );
    }
}
